import { render, staticRenderFns } from "./funny.vue?vue&type=template&id=7f079212&scoped=true&"
import script from "./funny.vue?vue&type=script&lang=js&"
export * from "./funny.vue?vue&type=script&lang=js&"
import style0 from "./funny.vue?vue&type=style&index=0&id=7f079212&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f079212",
  null
  
)

export default component.exports